module.exports = __webpack_public_path__ + "img/nokia-yam.ad09f676.png";